module.exports = __webpack_public_path__ + "img/wdhx.22f72e2b.jpg";